import { c as _c } from "react/compiler-runtime";
import { CollectionLockup, CollectionLockupContent, CollectionLockupTitle, MultiTraitTooltip } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { ItemAvatar, ItemContent, ItemDescription, ItemTitle, TextOverflowTooltip, tableRowSizeVariants, useTable } from "@opensea/ui-kit";
import { Item } from "../../../../../components/Item";
import { CancelOrderTableRowItem_orderFragment } from "./CancelOrderTableRowItem.fragment";
export const CancelOrderTableRowItem = t0 => {
  const $ = _c(5);
  const {
    order: orderKey
  } = t0;
  let t1;
  if ($[0] !== orderKey) {
    t1 = readFragment(CancelOrderTableRowItem_orderFragment, orderKey);
    $[0] = orderKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const order = t1;
  const {
    size
  } = useTable();
  let t2;
  if ($[2] !== order || $[3] !== size) {
    const {
      image
    } = tableRowSizeVariants({
      size
    });
    const {
      collection,
      item,
      side,
      type,
      traitIdentifier,
      traitIdentifiers
    } = order;
    t2 = side === "OFFER" && (type === "CRITERIA_COLLECTION" || type === "CRITERIA_TRAIT") ? <Item variant="unstyled"><ItemAvatar className={image()} src={collection.imageUrl} /><ItemContent><CollectionLockup collection={collection} size={size}><CollectionLockupContent><CollectionLockupTitle color="text-secondary" weight="regular" /></CollectionLockupContent></CollectionLockup>{traitIdentifier ? <ItemDescription>{traitIdentifier.traitType}: {traitIdentifier.value}</ItemDescription> : traitIdentifiers ? <ItemDescription><MultiTraitTooltip traits={traitIdentifiers} /></ItemDescription> : null}</ItemContent></Item> : item ? <Item variant="unstyled"><ItemAvatar className={image()} src={item.imageUrl} /><ItemContent><TextOverflowTooltip><ItemTitle>{item.name || `#${item.tokenId}`}</ItemTitle></TextOverflowTooltip><CollectionLockup collection={collection} size={size}><CollectionLockupContent><CollectionLockupTitle color="text-secondary" weight="regular" /></CollectionLockupContent></CollectionLockup></ItemContent></Item> : null;
    $[2] = order;
    $[3] = size;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};